import { render, staticRenderFns } from "./ButtonsWidget.vue?vue&type=template&id=509f7560&scoped=true&"
import script from "./ButtonsWidget.vue?vue&type=script&lang=js&"
export * from "./ButtonsWidget.vue?vue&type=script&lang=js&"
import style0 from "./ButtonsWidget.vue?vue&type=style&index=0&id=509f7560&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509f7560",
  null
  
)

export default component.exports